import { passCodes } from '../passCodes';
import cipher35Hint1 from '../../../../assets/images/games/zdar-escape-game/ciphers/35/hint1.webp';
import track35 from '../../../../assets/audio/tracks/track35.mp3';

const hints = [
    {
        image: cipher35Hint1,
    },
    {
        text: 'Kódem je: 1891',
        solution: true,
    },
];
export const step35graveyard = {
    id: 33,
    title: '16. stanoviště',
    taskText: `
        <p>
            Hele já už ji vidím, ty taky? Co nám asi řekne? Aha, říká, že to prý bylo něco, co je městu hodně blízké a bez čeho by to tu už nebylo jako dřív. Hodně to prý pro něj znamená, je to nějaký odkaz. 
        </p>
        <p>    
            Ty jo, ta je zase tajemná, jako vždycky. Možná si napiš že jsme u ní byli, kdyby se na to někdo ptal. Tady kousek vlevo je kostel a u něj je její syn, ten by mohl vědět víc. 
        </p>
        <p>    
            Tak jdeme, už začínám být trochu unavený a svačinka by bodla. Zadej letopočet, který u něj najdeš.
        </p>
    `,
    taskPreviewText:
        'Hele já už ji vidím, ty taky? Co nám asi řekne? Aha, říká, že to prý bylo něco, co je městu hodně blízké',
    audio: track35,
    cipher: {
        label: 'Úkol',
        text: 'Zadejte letopočet.',
    },
    snowAudio: track35,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[25],
    additionalInfo: 'Odpovědí je číslo.',
    catImage: 7,
    hints: hints,
    snowHints: hints,
};
